import { defineNuxtPlugin } from "nuxt/app";
import { useStrapi } from "#imports"; // if you have @nuxtjs/strapi module

export default defineNuxtPlugin((nuxtApp) => {
  const strapi = useStrapi(); // auto-imported
  nuxtApp.provide('strapi', strapi); // globally available as $strapi
});
